import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ButtonThemeEnum} from "../../shared/ui/button/button-theme-enum";
import {ParametreCalculConditionnementMl} from "../../core/models/gestion-conditionnements/parametre-calcul-conditionnement-ml";
import {TrancheReductionMl} from "../../core/models/gestion-conditionnements/tranche-reduction-ml";

@Component({
  selector: 'yo-parametre_calcul_conditionnement',
  templateUrl: './parametre-calcul-conditionnement.component.html',
  styleUrls: ['./parametre-calcul-conditionnement.component.scss']
})
export class ParametreCalculConditionnementComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  public newTranche: TrancheReductionMl = new TrancheReductionMl();

  @Input()
  public parametreCalculConditionnement: ParametreCalculConditionnementMl;

  @Output()
  public parametreCalculConditionnementChange: EventEmitter<ParametreCalculConditionnementMl> = new EventEmitter();

  constructor() {

  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

  public updateStartValue(value: Number): void {
    this.newTranche.start = value;
  }

  public updateQuantityAllowedValue(value: Number): void {
    this.newTranche.quantityAllowed = value;
  }

  public updateTrancheStartValue(value: Number, tranche: TrancheReductionMl): void {
    this.setParametrageEdited();
    tranche.start = value;
  }

  public updateTrancheQuantityAllowedValue(value: Number, tranche: TrancheReductionMl): void {
    this.setParametrageEdited();
    tranche.quantityAllowed = value;
  }

  public addTranche() {
    this.setParametrageEdited();
    let tranche: TrancheReductionMl = this.parametreCalculConditionnement.trancheReductionList.filter(tranche => tranche.start == this.newTranche.start)?.[0];
    if (tranche == null) {
      this.parametreCalculConditionnement.trancheReductionList.push(this.newTranche);
      this.parametreCalculConditionnement.trancheReductionList = this.parametreCalculConditionnement.trancheReductionList.sort((trancheA, trancheB) => trancheA.start.valueOf() - trancheB.start.valueOf());
    } else
      tranche.quantityAllowed = this.newTranche.quantityAllowed;
    this.newTranche = new TrancheReductionMl();
  }

  public deleteTranche(tranche: TrancheReductionMl) {
    this.setParametrageEdited();
    this.parametreCalculConditionnement.isEdited = true;
    this.parametreCalculConditionnement.trancheReductionList.splice(this.parametreCalculConditionnement.trancheReductionList.indexOf(tranche), 1);
  }

  public setParametrageEdited() {
    this.parametreCalculConditionnement.setEdited();
  }

  public onUpdateMinimumBarquetteRequired(number: number){
    this.setParametrageEdited();
    this.parametreCalculConditionnement.minimumBarquetteRequired = number;
  }
}
